import { pageMetadataSchema } from '../../../schema/pageMetadata.val';
import { c, nextAppRouter, s } from '../../../val.config';

export const schema = s.object({
  title: s.string(),
  placeholders: s.object({
    email: s.string(),
    background: s.string(),
    intention: s.string(),
  }),
  pageMetadata: pageMetadataSchema,
  form: s.object({
    missingEmailError: s.string(),
    missingBackgroundError: s.string(),
    missingMessageError: s.string(),
    positions: s.array(s.string()),
    successRoute: s.route(),
    errorRoute: s.route(),
  }),
});

export default c.define(
  '/app/(main)/kaffeprat/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/kaffeprat': {
      title: `Kult at du vil ta en prat med oss!`,
      placeholders: {
        email: '',
        background: '',
        intention: '',
      },
      form: {
        missingEmailError: 'E-posten er ugyldig.',
        missingBackgroundError:
          'Her må du nesten skrive noe før du sender inn!',
        missingMessageError: 'Her må du nesten skrive noe før du sender inn!',
        positions: ['Teknolog', 'Designer'],
        successRoute: '/kaffeprat/takk',
        errorRoute: '/kaffeprat/feil',
      },
      pageMetadata: {
        title: 'Kaffeprat',
        description:
          'Håper du tar deg tid å fylle ut vårt lille skjema. Da kan vi peke deg i riktig retning, og få til en bra prat.',
        image: {
          path: '/public/val/images/dbcb029cf591f7424afeba3f21cbf7f641e704ba-3500x2333.webp',
          width: 3500,
          height: 2333,
          mimeType: 'image/webp',
          alt: 'Fest på loftet',
        },
      },
    },
  }
);
